import { useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../../layout/Layout";
import { BOOK } from "./one-person-ten-people/storeConfig";
import cover from "../../../assets/one-person-ten-people-cover.png";
import "animate.css";

function Ebooks() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Layout>
      <div className="pt-16 md:pt-20 bg-white">
        <div className="flex flex-col space-y-2 sm:space-y-10 mx-auto py-2">
          <div className="flex justify-center items-center pl-6 pr-6 pb-16 md:pl-12 md:pr-12 lg:pl-24 lg:pr-24 bg-white">
            <div className="grid grid-cols-1 max-w-4xl items-stretch mx-auto gap-8">
              <p className="text-sm text-center text-slate-500">
                <Link to={BOOK.hubPath} className="link_hover_effect">
                  Digital Products
                </Link>
                <span className="mx-2">/</span>
                eBooks
              </p>
              <p className="text-4xl md:text-5xl text-center leading-normal">
                eBooks
              </p>
              <p className="text-xl md:text-2xl text-center leading-normal">
                These are books I write the way I work: from the problem, through
                the evidence, down to what you do on Monday. Not a stack of
                screenshots. Not a list of tools that will be dead by the time
                you finish reading.
              </p>
              <p className="text-md md:text-lg text-slate-600 text-center leading-normal">
                Open one when you need coverage. Come back when the next role
                shows up. The point is a manual you can keep using after the
                hype cycle moves on.
              </p>
            </div>
          </div>

          <div className="flex justify-center items-center pt-16 pl-6 pr-6 pb-24 md:p-24 bg-gray-50">
            <div className="grid grid-cols-1 max-w-6xl w-full mx-auto gap-10">
              <Link
                to={BOOK.salesPath}
                className="group grid grid-cols-1 lg:grid-cols-2 items-stretch gap-10 p-8 md:p-12 bg-white shadow-md rounded-2xl hover:shadow-lg transition-shadow duration-300"
              >
                <div className="flex justify-center items-center">
                  <img
                    src={cover}
                    alt={`${BOOK.title} cover`}
                    className="w-[220px] md:w-[260px] h-auto rounded-md shadow-xl border border-gray-200"
                  />
                </div>

                <div className="flex flex-col space-y-5">
                  <p className="text-3xl">{BOOK.title}</p>
                  <p className="text-gray-700 text-md leading-relaxed">
                    {BOOK.subtitle}. A working manual for the individual who has
                    to cover the ground a team used to cover — and the evidence
                    for what that actually takes.
                  </p>
                  <ul className="space-y-2 text-gray-700 text-md">
                    {BOOK.previewPoints.map((point) => (
                      <li key={point} className="flex gap-2">
                        <span className="text-black font-semibold">→</span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                  <span className="inline-flex w-fit bg-black group-hover:bg-white group-hover:text-black text-white font-normal text-md py-3 px-4 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                    View the eBook
                  </span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Ebooks;
